export const answerType = [
  {text: 'Система', value: 'SYSTEM'},
  {text: 'Вручную', value: 'MANUAL'}
]

export const answerTypeAsString = function(type) {
  return answerType.find(it => it.value === type).text
}
